import { render, staticRenderFns } from "./PurchaseInfo.vue?vue&type=template&id=6087692b&scoped=true&"
import script from "./PurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./PurchaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInfo.vue?vue&type=style&index=0&id=6087692b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087692b",
  null
  
)

export default component.exports